import React from 'react';
import { CreateForm, WysiwygInput } from 'framework/form';
import statusChangeReasonNoteValidation from 'domain/recruiting/candidate/applications/status/statusChangeReasonNoteValidation';
import useCandidateApplicationService, {
  CandidateApplicationStatus,
} from 'domain/recruiting/candidate/applications/shared/candidateApplicationService';
import { useListContext } from 'framework/list';
import { useCandidateService } from 'domain/shared/candidate';
import { OneStopButtonsLayout } from 'domain/shared/oneStop';
import { Modal } from 'framework/ui/ui-builder';

type StatusChangeReasonFormProps = {
  candidateId: string;
  candidateApplicationId: string;
  isModalOpen: boolean;
  closeFeedbackForm: () => void;
  status: CandidateApplicationStatus;
};

const StatusChangeReasonModalForm = ({
  candidateId,
  candidateApplicationId,
  isModalOpen,
  closeFeedbackForm,
  status,
}: StatusChangeReasonFormProps) => {
  const { createTimelineItem } = useCandidateService();
  const { partialUpdate } = useCandidateApplicationService();
  const { reloadData = () => {} } = useListContext();

  const onSubmit = async (data: any) => {
    await partialUpdate(candidateApplicationId, { status });
    await createTimelineItem(candidateId, 'notes', data);
  };

  return (
    <CreateForm
      submitFormFunc={onSubmit}
      afterSubmit={{
        execute: () => {
          closeFeedbackForm();
          reloadData();
        },
        message: 'You are awesome! The Candidate Application status has been successfully updated.',
      }}
      getValidationSchemaFunc={() => Promise.resolve(statusChangeReasonNoteValidation)}
    >
      <Modal
        key="modal-not-strict"
        modalSize="sm"
        backdrop="static"
        keyboard={false}
        isOpen={isModalOpen}
        hasCancelButton={false}
        title="Specify the reason for the status change"
        onToggle={closeFeedbackForm}
      >
        <WysiwygInput label="Timeline comment" labelHint="(Will be added to candidate timeline)" source="noteText" />
        <OneStopButtonsLayout onCancelAction={closeFeedbackForm} isFixed={false} />
      </Modal>
    </CreateForm>
  );
};

export default StatusChangeReasonModalForm;
